import clsx from "clsx";
import Image from "next/image";
import ReactLoading from "react-loading";

import closeSearchIcon from "@/assets/icons/close-gray.svg";
import searchIcon from "@/assets/icons/search-gray.svg";

type Props = {
  value: string;
  placeholder: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  enterKeyHandler?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onCompositionStart?: (e: React.CompositionEvent<HTMLInputElement>) => void;
  onCompositionEnd?: (e: React.CompositionEvent<HTMLInputElement>) => void;
  isActivated?: boolean;
  isLoading?: boolean;
};

/* 検索窓UI */
//MEMO: ひとまず検索結果リストは表示なしで作成
const SearchBox: React.FC<Props> = ({
  value,
  placeholder,
  setValue,
  onChange,
  onBlur,
  enterKeyHandler,
  onCompositionStart,
  onCompositionEnd,
  isActivated,
  isLoading
}) => {
  return (
    <div className="relative text-md">
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        className={clsx(
          "h-40 w-full rounded-sm border px-16 py-8",
          isActivated ? "border-cselected" : "border-cBorderGray"
        )}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={enterKeyHandler}
        onCompositionStart={onCompositionStart}
        onCompositionEnd={onCompositionEnd}
      />
      <div className="absolute right-8 top-12">
        {isActivated ? (
          <div className="cursor-pointer" onClick={() => setValue("")}>
            <Image src={closeSearchIcon} alt="消去" width={16} height={16} />
          </div>
        ) : isLoading ? (
          <ReactLoading
            color="#aaa"
            width="1.6rem"
            height="1.6rem"
            type="spin"
          />
        ) : (
          <Image src={searchIcon} alt="検索" width={16} height={16} />
        )}
      </div>
    </div>
  );
};

export default SearchBox;
